import { ReactNode } from "react";

import contribution1 from "@/assets/images/contribution1.svg";
import contribution2 from "@/assets/images/contribution2.svg";
import contribution3 from "@/assets/images/contribution3.svg";
import contribution4 from "@/assets/images/contribution4.svg";

export const textWithImageGridData: {
  heading: string;
  description: ReactNode;
  images: { src: string; alt: string }[];
} = {
  heading: "Our Team's Contribution in Pay it Forward",
  description: (
    <>
      <p>
        Our team have conducted various sessions thought our ellie clients and
        community.
      </p>
    </>
  ),
  images: [
    { src: contribution1, alt: "contribution1" },
    { src: contribution2, alt: "contribution2" },
    { src: contribution3, alt: "contribution3" },
    { src: contribution4, alt: "contribution4" },
  ],
};
